<template>
  <span v-if="configuracao" class="status-erro" :style="{ color: configuracao.cor }">
    <v-icon small :color="configuracao.cor" class="status-erro__icon">{{ configuracao.icone }}</v-icon>
    {{ configuracao.rotulo }}
  </span>
</template>

<script>
  export const coresStatusErro = Object.freeze({
    IDENTIFICADO: '#e58d9a',
    EM_DIAGNOSTICO: '#a8b5de',
    EM_CORRECAO: '#e6b07a',
    AGUARDANDO_VALIDACAO: '#d8c77a',
    ENCERRADO: '#83c7bf',
    REABERTO: '#be9dd8',
    NAO_APLICAVEL: '#aeb7c2'
  });

  export const iconesStatusErro = Object.freeze({
    IDENTIFICADO: 'mdi-alert-circle',
    EM_DIAGNOSTICO: 'mdi-eye-circle',
    EM_CORRECAO: 'mdi-progress-wrench',
    AGUARDANDO_VALIDACAO: 'mdi-clock-time-four',
    ENCERRADO: 'mdi-check-underline-circle',
    REABERTO: 'mdi-sync-alert',
    NAO_APLICAVEL: 'mdi-minus-circle'
  });

  export const statusErroDominante = (erros = []) => {
    const prioridade = [
      'IDENTIFICADO',
      'REABERTO',
      'EM_DIAGNOSTICO',
      'EM_CORRECAO',
      'AGUARDANDO_VALIDACAO',
      'ENCERRADO',
      'NAO_APLICAVEL'
    ];
    const status = erros.map((erro) => String(erro.status_erro || '').toUpperCase());

    return prioridade.find((item) => status.includes(item)) || null;
  };

  const configuracoes = {
    IDENTIFICADO: {
      icone: iconesStatusErro.IDENTIFICADO,
      cor: coresStatusErro.IDENTIFICADO,
      rotulo: 'Identificado'
    },
    EM_DIAGNOSTICO: {
      icone: iconesStatusErro.EM_DIAGNOSTICO,
      cor: coresStatusErro.EM_DIAGNOSTICO,
      rotulo: 'Em diagnóstico'
    },
    EM_CORRECAO: {
      icone: iconesStatusErro.EM_CORRECAO,
      cor: coresStatusErro.EM_CORRECAO,
      rotulo: 'Em correção'
    },
    AGUARDANDO_VALIDACAO: {
      icone: iconesStatusErro.AGUARDANDO_VALIDACAO,
      cor: coresStatusErro.AGUARDANDO_VALIDACAO,
      rotulo: 'Aguardando validação'
    },
    ENCERRADO: {
      icone: iconesStatusErro.ENCERRADO,
      cor: coresStatusErro.ENCERRADO,
      rotulo: 'Encerrado'
    },
    REABERTO: {
      icone: iconesStatusErro.REABERTO,
      cor: coresStatusErro.REABERTO,
      rotulo: 'Reaberto'
    },
    NAO_APLICAVEL: {
      icone: iconesStatusErro.NAO_APLICAVEL,
      cor: coresStatusErro.NAO_APLICAVEL,
      rotulo: 'Não aplicável'
    }
  };

  export default {
    name: 'StatusErro',

    props: {
      status: {
        type: String,
        required: true
      }
    },

    computed: {
      configuracao() {
        const status = String(this.status || '').toUpperCase();

        return configuracoes[status];
      }
    }
  };
</script>

<style scoped>
  .status-erro {
    align-items: center;
    display: inline-flex;
    font-size: 0.95rem;
    font-weight: normal;
  }

  .status-erro__icon {
    font-size: 0.9rem !important;
    margin-right: 1.7px;
  }
</style>
